// extracted by mini-css-extract-plugin
export default {"recos":"K5-z","productCardOverride":"L5-z","rowHasBadge":"M5-z"};